import { useEffect } from 'react';
import {
  hasLocationPermissionBeenAsked,
  requestLocationPermissionOnce,
} from '../utils/locationPermissionUtils';

/**
 * Prompt for location permission once when an authenticated layout mounts
 * (covers page refresh when the user already has a token).
 */
export function useLocationPermissionOnAuth() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || hasLocationPermissionBeenAsked()) return;
    requestLocationPermissionOnce();
  }, []);
}
